import { IHinhThucChiTietActionTypes } from "../../action-types/mien-giam/IHinhThucChiTietActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IHinhThucChiTietReducer } from "../../reducer-model/mien-giam/IHinhThucChiTietReducer";
const iniState: IHinhThucChiTietReducer = {
  status: eReducerStatusBase.is_not_initialization,
  hinhThucChiTiets: [],
  IDHinhThuc: 0,
};
export const hinhThucChiTietReducer = (
  state: IHinhThucChiTietReducer = iniState,
  action: IHinhThucChiTietActionTypes
): IHinhThucChiTietReducer => {
  switch (action.type) {
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        IDHinhThuc: action.payload,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        hinhThucChiTiets: action.payload,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        hinhThucChiTietEditing: action.payload,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        hinhThucChiTietEditing: undefined,
      };
    case "HINH_THUC_MIEN_GIAM_CHI_TIET_CHANGE_IDHINHTHUC":
      return {
        ...state,
        IDHinhThuc: action.payload,
        status: eReducerStatusBase.is_need_reload,
      };

    default:
      return state;
  }
};
